import Vue from 'vue'
import App from './App.vue'
import Element from 'element-ui'
import CalibratedSize from './utils/sizeCalc.js'

Vue.config.productionTip = false
Vue.prototype.$CalibratedSize = CalibratedSize;

Vue.use(Element)

new Vue({
  render: h => h(App),
}).$mount('#app')
